import { useAction } from '@spazious/react-hooks';
import { actions, selectAuth } from '@store';

const authActions = {
  setAuth: actions.setAuth,
  setUserConfig: actions.setUserConfig,
  upsertUsersGridConfig: actions.upsertUsersGridConfig,
};

/**
 * Returns the auth state and actions from store.
 */
export const useStoreAuth = () => useAction(selectAuth, authActions);

export default useStoreAuth;
